import { NavLink } from "react-router-dom";
import { House, Radio, MusicNotes, FilmStrip, BookBookmark, Compass } from "@phosphor-icons/react";
import { TEST_IDS } from "@/constants/testIds";

const items = [
  { to: "/", label: "Home", testId: TEST_IDS.nav.home, icon: House, end: true },
  { to: "/radios", label: "Radio", testId: TEST_IDS.nav.radios, icon: Radio },
  { to: "/music", label: "Music", testId: TEST_IDS.nav.music, icon: MusicNotes },
  { to: "/videos", label: "Video", testId: TEST_IDS.nav.videos, icon: FilmStrip },
  { to: "/discover", label: "Find", testId: TEST_IDS.nav.discover, icon: Compass },
  { to: "/library", label: "Library", testId: TEST_IDS.nav.library, icon: BookBookmark },
];

export default function BottomNav() {
  return (
    <nav data-testid="bottom-nav" style={{ paddingBottom: "env(safe-area-inset-bottom)" }} className="md:hidden fixed left-0 right-0 bottom-0 z-40 bg-[#05070d]/95 border-t border-white/10 backdrop-blur-2xl shadow-[0_-18px_60px_rgba(0,0,0,.42)]">
      <ul className="flex items-stretch justify-between">
        {items.map(it => (
          <li key={it.to} className="flex-1">
            <NavLink
              to={it.to}
              end={it.end}
              data-testid={it.testId}
              className={({ isActive }) => `min-h-[68px] flex flex-col items-center justify-center gap-1.5 py-2 px-1 font-mono text-[8px] uppercase tracking-[0.09em] transition-colors ${isActive ? "text-[#ff4d1d]" : "text-slate-300/70 hover:text-white"}`}
            >
              {({ isActive }) => (
                <>
                  <it.icon size={22} weight={isActive ? "fill" : "regular"} />
                  <span>{it.label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
